import React from 'react';
import { Alert, Button } from 'antd';

/**
 * แถบสรุปเหนือตาราง บอกว่าที่เลือกอยู่เกินสต็อกที่ item ไหนบ้าง
 * เป็นการเตือนเท่านั้น ไม่ได้ห้ามอนุมัติ ผู้ใช้ตัดสินใจเองได้
 * มีปุ่มเอาเฉพาะแถวที่เกินออก เผื่อไม่อยากไล่ติ๊กออกเองทีละแถว
 */
export const StockSelectionAlert = ({
  unavailable = false,
  overItems = [],
  selectedCount = 0,
  staleMinutes = 0,
  onRemoveOverSelected = () => {},
}) => {
  if (unavailable) {
    return (
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 12 }}
        message="ตรวจสอบสต็อกไม่ได้"
        description="เชื่อมต่อข้อมูลสต็อกจากระบบ CS ไม่ได้ ตารางจะไม่แสดงยอดคงเหลือ แต่ยังอนุมัติและออกใบส่งสินค้าได้ตามปกติ"
      />
    );
  }

  if (overItems.length === 0) {
    return null;
  }

  const detail = overItems
    .map(({ itemId, selected, available }) => `${itemId} เลือก ${selected} เหลือ ${available}`)
    .join(' | ');

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 12 }}
      message={`เลือก ${selectedCount} รายการ · เกินสต็อก ${overItems.length} รหัสสินค้า (เตือนเท่านั้น ยังอนุมัติได้)`}
      description={
        <>
          <div>{detail}</div>
          {staleMinutes > 0 && (
            <div style={{ fontSize: 12, marginTop: 4 }}>
              {`ข้อมูลสต็อกมาจากระบบ CS ทุก 15 นาที ถ้าเก่าเกิน ${staleMinutes} นาทีจะล็อกแถวไว้`}
            </div>
          )}
        </>
      }
      action={
        <Button size="small" danger onClick={onRemoveOverSelected}>
          ยกเลิกเฉพาะที่เกิน
        </Button>
      }
    />
  );
};
